import {
  websiteMediaFrame,
  type WebsiteFrameDevice,
  type WebsiteTemplateManifest,
} from '@dukanti/shared';

/**
 * Epic #228 P6 (UI/UX P2-3, coordinator decision): the one device a media
 * slot is FOR, or null when it renders on every device.
 *
 * - A slot the frame registry places on desktop only (a hero `desktopMedia`)
 *   is a desktop slot.
 * - Its sibling `<item>.media` is then the mobile slot: on desktop it only
 *   stands in while no desktop media is set, so the editor frames it for
 *   mobile only and leaves its stored desktop framing untouched.
 *
 * Every other slot (one picture on every device) returns null; the registry's
 * `perDevice` then decides between one shared frame and Desktop/Mobile tabs.
 */
export function websiteMediaSlotDevice(
  manifest: WebsiteTemplateManifest,
  slotId: string,
): WebsiteFrameDevice | null {
  const family = manifest.layoutFamily;
  if (websiteMediaFrame(family, slotId).device === 'desktop') return 'desktop';
  if (!slotId.endsWith('.media')) return null;
  const sibling = `${slotId.slice(0, -'.media'.length)}.desktopMedia`;
  const hasDesktopSibling = manifest.slots.some(
    (slot) => slot.id === sibling && slot.type === 'media',
  );
  return hasDesktopSibling && websiteMediaFrame(family, sibling).device === 'desktop'
    ? 'mobile'
    : null;
}
